import {
  Component,
  ElementRef,
  inject,
  Input, OnInit, AfterViewInit, OnDestroy
} from '@angular/core';
import { fromEvent, Subscription, throttleTime } from 'rxjs';
import {IndexIoService} from '../../../services/index-io.service';
import html2canvas from 'html2canvas-pro';
import jsPDF from 'jspdf';
import {NgIf} from '@angular/common';




@Component({
  selector: 'bnpp-indx-index-pdf-excel-pallete',
  imports: [NgIf],
  templateUrl: './index-pdf-excel-pallete.component.html',
  styleUrl: './index-pdf-excel-pallete.component.scss',
  standalone: true,
})
export class IndexPdfExcelPalleteComponent implements OnInit, AfterViewInit, OnDestroy {
  private indexInfoService = inject(IndexIoService);
  @Input() mdsCode:string= '';
  public deployUrlHost = this.indexInfoService.getDeployUrlHost();
  indexSubProductInfo = this.indexInfoService.indexSubProductInfo;

  protected isPalletPostionFix = false;
  private elementTopPosition = 0;
  private subscriptions: Subscription = new Subscription();

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    this.attachScrollListener();
  }

  ngAfterViewInit() {
    if (this.elementRef?.nativeElement && !this.elementTopPosition) {
      this.elementTopPosition =
        this.elementRef.nativeElement.getBoundingClientRect().top;
    }
  }

  private attachScrollListener(): void {
    const scroll$ = fromEvent(window, 'scroll');

    // Throttle the scroll events to 16ms (~60fps)
    this.subscriptions.add(scroll$
      .pipe(throttleTime(16, undefined, { leading: true, trailing: true }))
      .subscribe(() => {
        this.handleScroll();
      }));
  }

  private handleScroll(): void {
    requestAnimationFrame(() => {
      const scrollY =
        window.pageYOffset || document.documentElement.scrollTop || 0;
      const isFixed = scrollY > this.elementTopPosition;
      if (isFixed != this.isPalletPostionFix) {
        this.isPalletPostionFix = isFixed;
      }
    });
  }

  ngOnDestroy() {
    // Clean up the subscription to prevent memory leaks
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }


  async onExportPdf() {
    console.log('Export PDF called');
    if (!document.documentElement) {
      console.error('Report element not found');
      return;    }
    const element=document.getElementById('captureArea')!;
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      backgroundColor: '#ffffff',    });
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({      orientation: 'portrait',      unit: 'pt',
      format: 'a4',    });
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const imgProps = (pdf as any).getImageProperties(imgData);
    const imgWidth = imgProps.width;
    const imgHeight = imgProps.height;
    const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
    const imgScaledWidth = imgWidth * ratio;
    const imgScaledHeight = imgHeight * ratio;
    pdf.addImage(imgData, 'PNG', 0, 0, imgScaledWidth, imgScaledHeight, undefined, 'FAST');
    pdf.save(this.mdsCode + `.pdf`);
  }

  onExportXls() {
    console.log('Export Xls called');
    const selectedResident = localStorage.getItem('selectedResident')!;
    this.subscriptions.add(this.indexInfoService.downloadHistoricalPerformanceExcel(this.mdsCode,selectedResident).subscribe());
  }
}
